import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

import { Link, useNavigate, useParams } from "react-router-dom";
import { useBaseOwnerId, useModelCreate, useModelShow } from "@rhino-project/core/hooks";
import { asOpportunity } from "../lib/thirdDoorAdapters";

export default function OpportunityDetail() {
    const { id = "N/A" } = useParams();
    const navigate = useNavigate();
    const organizationId = useBaseOwnerId();
    const { resource } = useModelShow("anticipated_procurement" as any, id as any, { queryOptions: { enabled: !!id && id !== "N/A" } } as any);
    const opportunity = asOpportunity(resource ?? { id });
    const { mutate: createApplication, isPending, error } = useModelCreate("opportunity_application" as any);
    const startApplication = () => createApplication({ anticipated_procurement_id: id, organization_id: Number.isFinite(organizationId) ? organizationId : undefined, status: "draft" } as any, { onSuccess: () => navigate(`/opportunities/${id}`) });
  return (
   <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full grid gap-6">
      <Card className="border-border shadow-sm">
      <CardHeader>
      <CardTitle>{opportunity.title}</CardTitle>
      <CardDescription>Program detail view with eligibility, timeline, and key submission requirements.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center gap-3 text-sm">
      <Badge>Program category: {opportunity.program_category}</Badge>
      <Badge variant="secondary">Submission window: {opportunity.submission_window}</Badge>
      <Badge variant="outline">Eligibility: {opportunity.eligibility}</Badge>
      <Button className="ml-auto" disabled={isPending} onClick={startApplication}>{isPending ? "Starting..." : "Start Application"}</Button>
      <Button asChild variant="outline"><Link to="/opportunities">Back to Opportunities</Link></Button>
      </CardContent>
      {error && <p className="px-6 pb-4 text-sm text-destructive">Unable to start application. Please sign in and try again.</p>}
      </Card>

      <Card className="border-border shadow-sm">
      <CardHeader>
      <CardTitle>Requirements and Documents</CardTitle>
      <CardDescription>Reference documents and requirement matrix for this opportunity.</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
      <div className="overflow-x-auto">
      <Table>
      <TableHeader>
      <TableRow>
      <TableHead>Requirement</TableHead>
      <TableHead>Type</TableHead>
      <TableHead>Notes</TableHead>
      <TableHead>Download</TableHead>
      </TableRow>
      </TableHeader>
      <TableBody>
      {[
      ["Technical brief", "Mandatory", "Include deployment assumptions", "PDF"],
      ["Evidence package", "Mandatory", "TRL and market validation", "ZIP"],
      ["Security declaration", "Conditional", "Needed before contract phase", "DOC"],
      ].map((row) => (
      <TableRow key={row[0]}>
      <TableCell className="font-medium">{row[0]}</TableCell>
      <TableCell>{row[1]}</TableCell>
      <TableCell>{row[2]}</TableCell>
      <TableCell><Button size="sm" variant="outline" disabled>{row[3]}</Button></TableCell>
      </TableRow>
      ))}
      </TableBody>
      </Table>
      </div>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}